import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import LiveStudio from "@kaltura/mediaspace-features-live-studio";

export { TopBanner } from "@kaltura/mediaspace-features-live-studio";

export const render = getDsLayoutComponentRenderer(LiveStudio);
